export enum JobStatus {
  initialized = 'initialized',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  canceled = 'canceled',
}
